import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { isEmpty, isLoaded } from "react-redux-firebase";

import LoadingComponent from "../../components/LoadingComponent";

import LoginPage from "../Login";
import SplitwisePage from "../Splitwise";
import TokenAccept from "../../components/TokenAccept";
import SettingsPage from "../Settings";
import { fetchExternalData } from "../../redux/actions";
import TransactionsPage from "../Transactions";
import RecurringPage from "../Recurring";
import CheckoutPage from "../Checkout";
import AccountDeletedPage from "../AccountDeleted";
import Layout from "../../components/Layout";

export default () => {
  const user = useSelector((state) => state.firebase.auth);
  const profile = useSelector((state) => state.firebase.profile);
  const splitwise = useSelector((state) => state.splitwise);
  const dispatch = useDispatch();

  let match = useRouteMatch();

  useEffect(() => {
    if (isLoaded(profile)) {
      dispatch(fetchExternalData());
    }
  }, [profile, fetchExternalData]);

  if (!isLoaded(profile)) {
    return <LoadingComponent />;
  }
  return (
    <div>
      {isLoaded(user) && isEmpty(user) ? <Redirect to="/a/login" /> : null}
      <Switch>
        <Route exact path={match.path}>
          <Layout title="Transactions">
            <TransactionsPage />
          </Layout>
        </Route>
        <Route path={`${match.path}/recurring`}>
          <Layout title="Recurring Transactions">
            <RecurringPage />
          </Layout>
        </Route>
        <Route exact path="/splitwise">
          {splitwise.loaded ? <SplitwisePage /> : null}
        </Route>
        <Route path={`${match.path}/settings`}>
          <Layout title="Settings">
            <SettingsPage />
          </Layout>
        </Route>
        <Route path={`${match.path}/checkout`}>
          <Layout title="Subscription Checkout">
            <CheckoutPage />
          </Layout>
        </Route>
        <Route path={`${match.path}/login`}>
          {isLoaded(user) && !isEmpty(user) ? (
            <Redirect to="/a" />
          ) : (
            <Layout title="Reconcile" noBottomNav={true}>
              <LoginPage />
            </Layout>
          )}
        </Route>
        <Route path={`${match.path}/acount-deleted`}>
          <Layout title="Reconcile" noBottomNav={true}>
            <AccountDeletedPage />
          </Layout>
          )}
        </Route>
        <Route path="/token-accept">
          <TokenAccept />
        </Route>
      </Switch>
    </div>
  );
};
